<template>
  <div v-if="messageContext" class="time">
    <div class="content">
      <span class="time-item">{{ messageContext.text }},</span>
      <span v-if="messageContext.link" class="link" @click="onLink">去缴费</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'imCustomText',
  props: {
    message: {
      type: Object,
      default() {
        return {
          payload: {}
        }
      }
    }
  },
  data() {
    return {
      // messageContext: {
      //   text:
      //     '处方(编号884481237362671616)已审核，缴费后可药房取药或快递配送到家',
      //   link: {
      //     txt: '去缴费',
      //     url: 'http://*****'
      //   }
      // }
    }
  },
  computed: {
    messageContext() {
      const data = JSON.parse(this.message.payload.data)
      return data.content
    }
  },
  methods: {
    onLink() {
      this.$emit('link', this.messageContext)
    }
  }
}
</script>

<style lang="scss" scoped>
.time {
  margin: 0.426667rem 0;
  text-align: center;
  font-size: 0;

  .content {
    display: inline-block;
    vertical-align: top;
    padding: 0.213333rem 0.426667rem;
    font-size: 0.469333rem;
    line-height: 0.512rem;
    border-radius: 0.469333rem;
    background: #eeeeee;
    word-break: break-all;
  }
  .time-item {
    color: #888888;
  }

  .link {
    color: #0089ff;
  }
}
</style>
